import { Component, OnInit, Input, Pipe, PipeTransform } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Project } from '../.modal/project';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { MainService } from '../.providers/main.service';
import { Enterprise } from '../.modal/enterprise';
import { TagsInputComponents } from 'bootstrap-tagsinput';
import { Task } from '../.modal/task';
@Component({
	selector: 'app-create-project',
	templateUrl: './create-project.component.html',
	styleUrls: ['./create-project.component.css']
})
export class CreateProjectComponent implements OnInit {
	selectedProjectIndex = 0;
	newProject: Project = new Project();
	projects: FirebaseListObservable<any>;
	enterprises: Enterprise[];
	constructor(public db: AngularFireDatabase, public mainService: MainService) {
		this.projects = this.db.list(this.getCurrentUser().uid + '/projects');
		this.newProject = new Project();
	} 
	getTasksWithStatus(tasks, status) {
		var tasksWithStatus = [];
		for (var task of tasks) {
			if (task.status == status) {
				tasksWithStatus.push(task);
			}
		}
		return tasksWithStatus;
	}
	onTaskRemoved(index, proj, event) {
		var projectId = proj.id;
		var projectKey = proj.$key;
		var enterpriseId = proj.enterpriseId;
		this.selectedProjectIndex = index;
		debugger;
		var oldTask = new Task();
		oldTask.taskId = event.taskId;
		oldTask.taskName = event.taskName;
		oldTask.taskShortName = event.taskName;
		console.log(oldTask + ':' + projectId + ':' + projectKey);
		for (var project of this.mainService.projects) {
			if (project.id == projectId) {
				var taskIndex = -1;
				var loopCounter = 0;
				var oldTask: Task;
				for (var task of project.tasks) {
					if (task.taskId == oldTask.taskId) {
						taskIndex = loopCounter;
						oldTask = task;
						break;
					}
					loopCounter++;
				}
				if (taskIndex != -1) {
					oldTask.status = 1; //1 - deleted
					project.tasks.splice(taskIndex, 1);
					project.tasks.push(oldTask);
				}
				console.log(project);
				this.mainService.updateProject(enterpriseId, projectKey, project);
			}
		}
	}
	onTaskAdded(index, proj, event) {
		var projectId = proj.id;
		var projectKey = proj.$key;
		var enterpriseId = proj.enterpriseId;
		this.selectedProjectIndex = index;
		var newTask = new Task();
		newTask.taskName = event.taskName;
		newTask.taskShortName = event.taskName;
		console.log(newTask + ':' + projectId + ':' + projectKey);
		for (var project of this.mainService.projects) {
			if (project.id == projectId) {
				if (project.tasks == null) {
					project.tasks = [];
				}
				project.tasks.push(newTask);
				console.log(project);
				this.mainService.updateProject(enterpriseId, projectKey, project);
			}
		}
	}
	ngOnInit() {
		var self = this;
		this.enterprises = this.mainService.getEnterprises(
			function() {
				$('.enterpriseLoader').show();
				$('.enterpriseNonLoader').hide();
			},
			function() {
				$('.enterpriseLoader').hide();
				$('.enterpriseNonLoader').slideDown();
				self.mainService.getProjects(
					function() {
						$('.projectLoader').show();
						$('.projectNonLoader').hide();
					},
					function() {
						$('.projectLoader').hide();
						$('.projectNonLoader').slideDown();
					}
				);
			}
		);
		this.getExistingProjects();
	}

	createProject(f: NgForm) {
		debugger;
		console.log(f.value);
		if (f.value.enterprise == '') {
			f.value.enterprise = $('#inpEnterprise')
				.find(':selected')
				.val();
		}
		this.newProject.name = f.value.name; //'Pandesco - Store Tool';
		this.newProject.shortName = f.value.shortName; //'Pandesco-ST';
		this.newProject.users = [this.getCurrentUser().uid];
		this.mainService.createProject(this.newProject, f.value.enterprise);
		f.setValue({ name: '', shortName: '' });
	}
	getCurrentUser() {
		return JSON.parse(localStorage.getItem('user'));
	}
	getExistingProjects() {
		var projects = [];
		var user = JSON.parse(localStorage.getItem('user'));
		var userData = this.db.list(user.uid);
		userData.subscribe(data => {
			for (var i = 0; i < data.length; i++) {
				console.log(data[i].$key);
				if (data[i].$key == 'projects') {
					projects = data[i];
					console.log(projects);
					break;
				}
			}
		});
		return projects;
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/create-project/create-project.component.ts